/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WarningModalComponent} from './warning-modal.component';
import {GenericModalModule} from '../../../../shared/generic-modal/generic-modal.module';
import {ActiveInputModule} from '../active-input/active-input.module';
import {InputModule} from '../../../../shared/input/input.module';

@NgModule({
    declarations: [WarningModalComponent],
    imports: [
        CommonModule,
        GenericModalModule,
        ActiveInputModule,
        InputModule
    ]
})
export class WarningModalModule {
}
